import {
    Card,
    CardHeader,
    CardFooter,
    CardTitle,
    CardDescription,
    CardContent,
} from '../ui/card.js';
import { cn } from '../../utils.js';

export function MemoraiCard({ children, className, ...props }: React.ComponentProps<typeof Card>) {
    return (
        <Card className={cn('bg-background border-border shadow-none rounded-lg', className)} {...props}>
            {children}
        </Card>
    );
}

export function MemoraiCardHeader({ children, className, ...props }: React.ComponentProps<typeof CardHeader>) {
    return <CardHeader className={cn('p-4 pb-2', className)} {...props}>{children}</CardHeader>;
}

export function MemoraiCardTitle({ children, className, ...props }: React.ComponentProps<typeof CardTitle>) {
    return <CardTitle className={cn('text-lg font-semibold tracking-tight text-foreground', className)} {...props}>{children}</CardTitle>;
}

export function MemoraiCardDescription({ children, className, ...props }: React.ComponentProps<typeof CardDescription>) {
    return <CardDescription className={cn('text-sm text-foreground-subtle', className)} {...props}>{children}</CardDescription>;
}

export function MemoraiCardContent({ children, className, ...props }: React.ComponentProps<typeof CardContent>) {
    return <CardContent className={cn('p-4 pt-2', className)} {...props}>{children}</CardContent>;
}

export function MemoraiCardFooter({ children, className, ...props }: React.ComponentProps<typeof CardFooter>) {
    return <CardFooter className={cn('p-4 pt-2 border-t border-border/50', className)} {...props}>{children}</CardFooter>;
}
